import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import cx from 'classnames'
import {replace} from '../../core/extract'
import {max} from '../../core/mathz'
import {connectLocationChangeLock} from '../../core/redux/router'
import {infoStatus} from '../../core/redux/status'
import Rating from '../../core/components/Rating'
import DashboardPanel from '../../core/components/DashboardPanel'
import DashboardPanelAdd from '../../core/components/DashboardPanelAdd'
import AverageNoteDashboardPanel from './AverageNoteDashboardPanel'
import i18n from '../i18n'
import style from './CampaignDashboard.less'

function questionAggregator(question) {
    return {
        question,
        averageNote: 0
    }
}

function noteAggregator(result, note) {
    const aggrega = result.find((a) => a.question.uid == note.questionUid)

    if (aggrega) {
        aggrega.averageNote = note.averageNote
    } else {
        console && console.warn('Question ' + note.questionUid + ' doesn\'t exist')
    }
    return result
}

class CampaignDashboard extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            aggregation: []
        }
    }

    componentWillMount() {
        const {dispatch, campaign} = this.props

        const answerRate = campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod
        const maxScore = max({source: campaign.notationScale, identify: (s) => s.position})
        const questionAggregation = campaign.questions.map(questionAggregator).reverse()
        const aggregation = campaign.stats.questionsAverageNote.reduce(noteAggregator, questionAggregation)
        this.setState({answerRate, maxScore, aggregation})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign != this.props.campaign) {
            const {dispatch, campaign} = nextProps

            const answerRate = campaign.stats.answersNumber / campaign.stats.ticketsNumberOnCampaignPeriod
            const maxScore = max({source: campaign.notationScale, identify: (s) => s.position})
            const questionAggregation = campaign.questions.map(questionAggregator).reverse()
            const aggregation = campaign.stats.questionsAverageNote.reduce(noteAggregator, questionAggregation)
            this.setState({answerRate, maxScore, aggregation})
        }
    }

    render() {
        const {dispatch, campaign} = this.props
        const {answerRate, maxScore, aggregation} = this.state

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <div>
                <Row>
                    <Col sm={6} md={4}>
                        <AverageNoteDashboardPanel light />
                        <DashboardPanel light
                            header={panelHeader(i18n.answerCount)}>
                            <div className={cx(style.answerCount, {[style.danger]: answerRate < campaign.answersRateGoal})}>
                                <span className={style.count}>{campaign.stats.answersNumber}</span>
                                <p>{replace(i18n.outOfEligibleTicketCount, {ticketCount: campaign.stats.ticketsNumberOnCampaignPeriod})}</p>
                            </div>
                        </DashboardPanel>
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanelAdd 
                            onClick={() => dispatch(infoStatus(i18n.featureNotImplemented))} />
                        <DashboardPanel light
                            header={panelHeader(i18n.answerRate)}>
                            <div className={cx(style.answerRate, {[style.danger]: answerRate < campaign.answersRateGoal})}>
                                <span className={style.rate}>{Math.round(answerRate * 100)}%</span>
                                {campaign.answersRateGoal && (
                                    <p>{replace(i18n.forAnswerGoal, {answerGoal: Math.round(campaign.answersRateGoal * 100)})}</p>
                                )}
                            </div>
                        </DashboardPanel>
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanel light
                            size='large'
                            header={panelHeader(i18n.answers)}>
                            <ul className={style.answerGroup}>
                                {aggregation.map((aggrega, aggregaIndex) => (
                                    <li
                                        key={aggrega.question.uid}>
                                        <h4>{aggrega.question.text}</h4>
                                        <Rating
                                            range={maxScore}
                                            label={i18n.score}
                                            value={aggrega.averageNote} />
                                    </li>
                                ))}
                            </ul>
                        </DashboardPanel>
                    </Col>
                </Row>
            </div>
        )
    }
}

CampaignDashboard = connectLocationChangeLock()(CampaignDashboard)

CampaignDashboard = connect((state) => ({
    location: state.router.location,
    campaign: state.satisfaction.campaign.campaign
}))(CampaignDashboard)

export default CampaignDashboard


// WEBPACK FOOTER //
// ./lib/satisfaction/components/CampaignDashboard.js